/**
 * Cosa manca per creare la scadenza secondo chi carica il documento: se lo carica il consulente il
 * documento appartiene a un solo cliente (il selettore ne ammette uno) e va allegato subito.
 */
export type DocumentUploaderGate = 'ready' | 'noClient' | 'documentMissing';

interface DocumentUploaderGateInput {
  clientCanUpload: boolean;
  clientCount: number;
  hasDocument: boolean;
}

export function resolveDocumentUploaderGate({
  clientCanUpload,
  clientCount,
  hasDocument,
}: DocumentUploaderGateInput): DocumentUploaderGate {
  if (clientCanUpload) {
    return 'ready';
  }
  if (clientCount === 0) {
    return 'noClient';
  }
  return hasDocument ? 'ready' : 'documentMissing';
}
